var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 13.5V7.00005H3.5V13.5C3.5 13.7762 3.72386 14 4 14H13C13.2761 14 13.5 13.7762 13.5 13.5V7.00005H14.5V13.5C14.5 14.3285 13.8284 15 13 15H4C3.17157 15 2.5 14.3285 2.5 13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2.50005V6.00005L11.5 4.00005V2.50005C11.5 2.2239 11.7239 2.00005 12 2.00005H13C13.2761 2.00005 13.5 2.2239 13.5 2.50005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79289 1.50005C8.18342 1.10952 8.81658 1.10952 9.20711 1.50005L15.8536 8.14649C16.0488 8.34176 16.0488 8.65834 15.8536 8.8536C15.6583 9.04886 15.3417 9.04886 15.1464 8.8536L8.5 2.20715L1.85355 8.8536C1.65829 9.04886 1.34171 9.04886 1.14645 8.8536C0.951184 8.65834 0.951184 8.34176 1.14645 8.14649L7.79289 1.50005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.b7bf2924da2c71f19613308c711ba191.svg";
export { ForwardRef as ReactComponent };